import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { NgRxActionProps } from 'src/app/core/state/models/ngrx-action-props.model';

export const SoftBanActions = createActionGroup({
  source: 'SoftBanFeature',
  events: {
    'Init State': emptyProps(),
    'Reset State': props<NgRxActionProps>(),
    'Get Status': props<NgRxActionProps>(),
    'Set Status': props<NgRxActionProps<{ status: boolean }>>(),
    'Add Modal Shown Route': props<NgRxActionProps<{ route: string }>>(),
  },
});
